export default __webpack_public_path__ + "b45adc30ddff52bf00b3293a3086b33d.svg";